var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6778,
    cy: 44.6778,
    r: 31.5521,
    fill: "#0D6EFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6304 53.0722L82.895 66.6601L67.9836 67.9836L66.6601 82.895L53.0722 76.6304L44.4254 88.8507L35.7785 76.6304L22.1906 82.895L20.8671 67.9836L5.95573 66.6601L12.2203 53.0722L0 44.4254L12.2203 35.7785L5.95573 22.1906L20.8671 20.8671L22.1906 5.95573L35.7785 12.2203L44.4254 0L53.0722 12.2203L66.6601 5.95573L67.9836 20.8671L82.895 22.1906L76.6304 35.7785L88.8507 44.4254L76.6304 53.0722ZM74.4246 61.719L69.5277 51.1311L79.0568 44.4254L69.5277 37.7196L74.4246 27.1317L62.7778 26.0729L61.719 14.4261L51.1311 19.323L44.4254 9.79387L37.7196 19.323L27.1317 14.4261L26.0729 26.0729L14.4261 27.1317L19.323 37.7196L9.79387 44.4254L19.323 51.1311L14.4261 61.719L26.0729 62.7778L27.1317 74.4246L37.7196 69.5277L44.4254 79.0568L51.1311 69.5277L61.719 74.4246L62.7778 62.7778L74.4246 61.719Z",
    fill: "#0D6EFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4254 72.1912C59.76 72.1912 72.1912 59.7601 72.1912 44.4254C72.1912 29.0907 59.76 16.6595 44.4254 16.6595C29.0907 16.6595 16.6595 29.0907 16.6595 44.4254C16.6595 59.7601 29.0907 72.1912 44.4254 72.1912Z",
    fill: "white",
    stroke: "#0D6EFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 46.2477L40.7879 51.3706",
    stroke: "#21B252",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5953 37.6665L40.7879 51.3704",
    stroke: "#21B252",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/Verification Icon.df9a3245dfbe4dfa17daf6f526126d9c.svg";
export { ForwardRef as ReactComponent };